<span matSnackBarLabel class="message-box custom-snack-bar-span">
  <span class="custom-snack-bar-span">
    <app-icon [size]="'medium'" [color]="'system-green'" [hoverColor]="'system-green'" class="circle-icon">check_circle</app-icon>
  </span>
  <span class="custom-snack-bar-span">{{ data }}</span>
</span>
<span class="close-action custom-snack-bar-span" matSnackBarActions>
  <app-a mat-button matSnackBarAction class="close-button" (click)="snackBarRef.dismissWithAction()">
    <app-icon color="ink-100" hoverColor="ink-100" class="close-icon">close</app-icon>
  </app-a>
</span>
